import React from 'react';
import type { PiV2Note } from '../../../patient-insurance/typesV2';
import { Pill } from '../../Pill/Pill';
import { PatientProfileSectionCard } from '../PatientProfileSectionCard';

export interface PatientInsuranceNotesProps {
  notes: PiV2Note[];
}

/**
 * Insurance Notes (spec §18) — human-entered context that may not exist in
 * electronic sources. An additional source, always labelled as manually entered;
 * it does not replace ELVA's evidence system.
 */
export function PatientInsuranceNotes({ notes }: PatientInsuranceNotesProps) {
  if (notes.length === 0) return null;

  return (
    <PatientProfileSectionCard icon="clipboard" title="Insurance notes" accent="var(--gold)">
      <div className="flex flex-col gap-2.5">
        {notes.map((n) => (
          <div
            key={n.id}
            className="rounded-[var(--r-md)] border border-[var(--cream-2)] bg-[var(--cream-0)] p-3"
          >
            <p className="m-0 text-[12.5px] leading-[1.5] text-[var(--ink-1)]">{n.text}</p>
            <div className="mt-1.5 flex flex-wrap items-center gap-2 text-[11px] text-[var(--ink-4)]">
              <span>{n.at}</span>
              <span>·</span>
              <span>{n.staff}</span>
              {n.reference != null && n.reference !== '' ? (
                <>
                  <span>·</span>
                  <span className="font-[var(--font-mono)]">Ref #{n.reference}</span>
                </>
              ) : null}
              <span className="ml-auto">
                <Pill tone="neutral">Manually entered</Pill>
              </span>
            </div>
          </div>
        ))}
      </div>
    </PatientProfileSectionCard>
  );
}
